import { fetchNotifications, deleteNotifications, readNotifications } from "../../../core/api";
import update from "immutability-helper";
import { checkHttpStatus, parseJSON } from "../../../utils";
import { findById } from "../../../core/utils"

// ------------------------------------
// Constants
// ------------------------------------
export const NOTIFICATION_FETCH_FAILURE = 'NOTIFICATION_FETCH_FAILURE';
export const NOTIFICATION_FETCH_REQUEST = 'NOTIFICATION_FETCH_REQUEST';
export const NOTIFICATION_FETCH_SUCCESS = 'NOTIFICATION_FETCH_SUCCESS';
export const NOTIFICATION_DELETE_SUCCESS = 'NOTIFICATION_DELETE_SUCCESS';
export const READ_NOTIFICATIONS_SUCCESS = 'READ_NOTIFICATIONS_SUCCESS'
export const READ_NOTIFICATIONS_FAILURE = 'READ_NOTIFICATIONS_FAILURE'


// ------------------------------------
// Actions
// ------------------------------------
export function requestingNotification() {
    return {
        type: NOTIFICATION_FETCH_REQUEST,
        payload: null,
    };
}

export function requestNotificationSuccess(json) {
    return {
        type: NOTIFICATION_FETCH_SUCCESS,
        payload: json
    };
}
export function requestNotificationFailure(json) {
    return {
        type: NOTIFICATION_FETCH_FAILURE,
        payload: json,
    };
}

export function requestNotificationDeleteSuccess(id) {
    return {
        type: NOTIFICATION_DELETE_SUCCESS,
        payload: id,
    };
}

export function requestReadNotificationSuccess() {
    return {
        type: READ_NOTIFICATIONS_SUCCESS,
    }
}

export function requestReadNotificationFailure() {
    return {
        type: READ_NOTIFICATIONS_FAILURE
    }
}



export function getNotificationList(id, payload) {
    return dispatch => {
        dispatch(requestingNotification());
        return fetchNotifications(id, payload)
            .then(checkHttpStatus)
            .then(parseJSON)
            .then(response => {
                return dispatch(requestNotificationSuccess(response));
            })
            .catch(error => {
                return dispatch(requestNotificationFailure(error))
            });
    };
}

export function readNotificationList(ids) {
    return dispatch => {
        return readNotifications(ids)
            .then(checkHttpStatus)
            .then(parseJSON)
            .then(response => {
                return dispatch(requestReadNotificationSuccess())
            })
            .catch(error => {
                return dispatch(requestReadNotificationFailure())
            })
    }

}

export function removeNotification(id) {
    return dispatch => {
        return deleteNotifications(id)
            .then(checkHttpStatus)
            .then(response => {
                dispatch(requestNotificationDeleteSuccess(id));
            })
            .catch(error => {
                console.log(error)
            });
    };
}


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
    [NOTIFICATION_FETCH_SUCCESS]: (state, action) => {
        const count = action.payload.results.filter(value => value.is_read != true).length;
        return update(state, {
            notifications: { $set: action.payload.results },
            notificationCount: { $set: count }

        })
    },
    [NOTIFICATION_DELETE_SUCCESS]: (state, action) => {
        const id = action.payload;

        const notificationList = state.notifications;
        const idx = notificationList.findIndex(findById, id);
        let newState = state;
        let count = 0;
        // Update bids
        if (idx !== -1) {
            const value = notificationList[idx]
            if(value.is_read ===true){
                count = state.notificationCount
            } else {
                count = state.notificationCount - 1
            }
            newState = update(state, {
                notifications: { $set: [...notificationList.slice(0, idx), ...notificationList.slice(idx + 1)] },
                notificationCount: { $set: count}
            });
        }
        return newState;
    },

    [READ_NOTIFICATIONS_SUCCESS]: (state) => {
        return update(state, {
            notificationCount: { $set: 0 }
        })
    }
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
    notifications: [],
    notificationCount: 0
};

export default function registerReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
}


// WEBPACK FOOTER //
// src/routes/notification/modules/notification.js